import { render, staticRenderFns } from "./Tview.vue?vue&type=template&id=e8848a88"
import script from "./Tview.vue?vue&type=script&lang=js"
export * from "./Tview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports